import React, { useEffect } from 'react';
import { Card, Descriptions, Avatar, Button, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useAuth } from '../store/AuthContext';
import { useTranslation } from 'react-i18next';

const ProfilePage: React.FC = () => {
    const { user, logout } = useAuth();
    const { t } = useTranslation();

    useEffect(() => {
        if (!user) {
            message.error(t('no_user_data_found'));
        }
    }, [user, t]);

    return (
        <Card
            title={t('profile')}
            style={{ maxWidth: 600, margin: 'auto', marginTop: 40 }}
            extra={<Button danger onClick={logout}>{t('logout')}</Button>}
        >
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                <Avatar size={64} icon={<UserOutlined />} />
                <div style={{ marginLeft: 16 }}>
                    <h2>{user?.name}</h2>
                    <p>{user?.email}</p>
                </div>
            </div>

            <Descriptions bordered column={1}>
                <Descriptions.Item label={t('name')}>
                    {user?.name || t('not_available')}
                </Descriptions.Item>
                <Descriptions.Item label={t('email')}>
                    {user?.email || t('not_available')}
                </Descriptions.Item>
                <Descriptions.Item label={t('role')}>
                    {user?.role?.name || t('not_available')}
                </Descriptions.Item>
                <Descriptions.Item label={t('permissions_')}>
                    {(user?.role?.permissions || []).map((p: any) => p.name).join(', ') || t('none')}
                </Descriptions.Item>
            </Descriptions>
        </Card>
    );
};

export default ProfilePage;
